var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"wximg",attrs:{"src":"img/ketang.png"}}),_c('div',{staticClass:"gotext",on:{"click":function($event){return _vm.goApp()}}},[_vm._v("点击跳转")])])}
var staticRenderFns = []

export { render, staticRenderFns }